import React, { useState } from "react";
import {
  Button,
  Grid,
  TextField,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
const GroupIdRangeSelection = ({ closeRangeDailog, getGroups }) => {
  const [startCount, setStartCount] = useState("");
  const [endCount, setEndCount] = useState("");
  const [emptyErr, setEmptyErr] = useState(false);
  const [invalidEntry, setInvalidEntry] = useState(false);
  const getGroupRange = () => {
    if (
      startCount &&
      startCount.trim() !== "" &&
      endCount &&
      endCount.trim() !== ""
    ) {
      if (startCount === "0" || endCount === "0") setInvalidEntry(true);
      else getGroups([parseInt(startCount), parseInt(endCount)]);
    } else setEmptyErr(true);
  };
  return (
    <div>
      <h5>Please Enter Scenario Group-Id Range</h5>
      <Grid container>
        <Grid item sm={2} alignContent="center">
          <h6>Range:</h6>
        </Grid>
        <Grid item sm={4}>
          <TextField
            required
            variant="outlined"
            id="start-range"
            label="Start Range"
            value={startCount}
            onChange={(e) => {
              invalidEntry && setInvalidEntry(false);
              emptyErr && setEmptyErr(false);
              setStartCount(e.target.value);
            }}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item sm={1} alignContent="center" style={{marginTop: '1rem', marginLeft: '1rem'}}>
          <h6>to</h6>
        </Grid>
        <Grid item sm={4}>
          <TextField
            required
            variant="outlined"
            id="end-range"
            label="End Range"
            value={endCount}
            onChange={(e) => {
              invalidEntry && setInvalidEntry(false);
              emptyErr && setEmptyErr(false);
              setEndCount(e.target.value);
            }}
            fullWidth
            margin="normal"
          />
        </Grid>
        <div style={{ marginTop: "-1rem", marginLeft: "7rem" }}>
          {invalidEntry && (
            <span style={{ color: "#d32f2f" }}>
              Count should be greater than 0 *
            </span>
          )}
        </div>
        <div style={{ marginTop: "-1rem" }}>
          {emptyErr && (
            <span style={{ color: "#d32f2f" }}>
              Please enter scenario group-id range *
            </span>
          )}
        </div>
        {/* <Grid item sm={12}>
          <RadioGroup
            aria-label="quiz"
            name="quiz"
            value={radioVal}
            onChange={handleRadioChange}
            style={{ flexDirection: "row", margin: "-0.5rem 0 -4rem 6rem" }}
          >
            <FormControlLabel value="fctw" control={<Radio />} label="FCTW" />
            <FormControlLabel
              value="nonFctw"
              control={<Radio />}
              label="Non-FCTW"
            />
          </RadioGroup>
        </Grid> */}
        <Grid item sm={12} sx={{ mt: -2 }}>
          <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
            <Button
              onClick={closeRangeDailog}
              variant="outlined"
              style={{ marginRight: "1rem" }}
            >
              Close
            </Button>
            <Button
              onClick={getGroupRange}
              variant="outlined"
              style={{
                backgroundColor: "#622AD8",
                color: "white",
                "&:hover": {
                  backgroundColor: "#303f9f",
                },
              }}
            >
              Proceed
            </Button>
          </Box>
        </Grid>
        {/* <Grid item sm={6}>
        </Grid> */}
      </Grid>
    </div>
  );
};
export default GroupIdRangeSelection;
